import { Injectable } from '@angular/core';
import { EQueryTab } from './models/e-query-tab.enum';
import { ExternalUserEQuery } from './models/external-user-e-query';
import { SubjectTitleRenderer } from '../renderer/subject-title-renderer';

interface SortInfo {
    columns: ((eq: ExternalUserEQuery) => string | number)[];
    sortDirection: ('asc' | 'desc')[];
}

type GridDefaultSortInfo = {
    [key in EQueryTab]: SortInfo;
};

@Injectable()
export class ExternalUserEQueriesGridDefaultSort {
    private readonly eQuerySortColumns: GridDefaultSortInfo = {
        [EQueryTab.awaiting]: {
            columns: [
                (eq: ExternalUserEQuery) => eq.eQueryAge.ticks
            ],
            sortDirection: [ 'desc' ],
        },
        [EQueryTab.submitted]: {
            columns: [
                (eq: ExternalUserEQuery) => SubjectTitleRenderer.renderSubjectNumberOrScreening(eq),
                (eq: ExternalUserEQuery) => eq.visitCollectionDate
                    ? eq.visitCollectionDate.valueOf()
                    : null
            ],
            sortDirection: [ 'asc', 'desc' ],
        }
    };

    public getByTab(tab: EQueryTab): SortInfo {
        const sortingInfo = this.eQuerySortColumns[tab];

        if (!sortingInfo) {
            throw new Error(`Unexpected ${tab} tab`);
        }

        return sortingInfo;
    }
}